import { render, staticRenderFns } from "./FormAssignStudent.vue?vue&type=template&id=0bcc0120&scoped=true&"
import script from "./FormAssignStudent.vue?vue&type=script&lang=js&"
export * from "./FormAssignStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc0120",
  null
  
)

export default component.exports